import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, account }) => {
  if (!isOpen || !account) return null;

  const hasChildren = account?.children && account?.children?.length > 0;
  const hasActivity = account?.hasActivity;

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-1030 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-2xl w-full max-w-md">
        <div className="p-4 md:p-6">
          <div className="flex items-start gap-4 mb-4 md:mb-6">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-error/10 flex items-center justify-center flex-shrink-0">
              <Icon name="AlertTriangle" size={24} color="var(--color-error)" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-2">
                Delete Account?
              </h3>
              <p className="font-body text-sm md:text-base text-muted-foreground">
                Are you sure you want to delete the account "{account?.name}" ({account?.code})?
              </p>
            </div>
          </div>

          {(hasChildren || hasActivity) && (
            <div className="bg-warning/10 border border-warning/20 rounded-md p-4 mb-4 md:mb-6">
              <div className="flex items-start gap-3">
                <Icon name="AlertCircle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <p className="font-body font-medium text-sm text-foreground mb-2">
                    Warning
                  </p>
                  {hasChildren && (
                    <p className="caption text-muted-foreground mb-1">
                      • This account has {account?.children?.length} sub-account(s) that will also be deleted
                    </p>
                  )}
                  {hasActivity && (
                    <p className="caption text-muted-foreground">
                      • This account has transaction history that will be affected
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="flex flex-col-reverse md:flex-row gap-3">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              fullWidth
              className="md:flex-1"
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="destructive"
              onClick={() => {
                onConfirm(account);
                onClose();
              }}
              fullWidth
              className="md:flex-1"
              iconName="Trash2"
              iconPosition="left"
            >
              Delete Account
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;